<div>
    <div class="p-3" *ngIf="fb && fb.error">
        <lib-error [title]="getText()" [error]="fb.error"></lib-error>
    </div>
    <form *ngIf="formGroup?.controls" (ngSubmit)="submitEvent.emit(formGroup)" [formGroup]="formGroup" 
        class="col-sm-12 px-0">
        <ng-content></ng-content>
        <div *ngIf="isBusy && !silentLoading" class="center-translation load-container">
            <lib-loading
            style="width: 200px"
            [status]="'text-info'" 
            [spinnerPosition]="true"
            [size]="'md'">
            </lib-loading>
        </div>
        <div class="col-12" *ngIf="showButtons" [ngClass]="{'p-3' : smartViewUsedInModal, 'p-0' : smartViewUsedInForm,'cont-padding' : !(smartViewUsedInForm || smartViewUsedInModal)}">
            <div class="d-xl-flex align-items-end" [ngClass]="{'button-container' : buttonContainerRequired && !smartViewUsedInModal}">
                <div class="p-0 col-12 text-right modal-buttons" *ngIf="smartViewUsedInModal">
                    <button *ngIf="!removeResetButton" [disabled]="!formGroup.dirty" class="btn btn-secondary mb-4" type="button" (click)="resetEvent.emit(true)">{{ resetCaption }}</button>
                    <button *ngIf="isCloseButtonRequired" type="button" (click)="closeEmitter.emit(false)" class="btn btn-danger ml-4 mb-4">Cancel</button>
                    <button [disabled]="submitButtonDisabled || !formGroup.valid || !formGroup.dirty" type="submit" class="btn btn-success ml-4 mb-4">{{ captionSaveText }}</button>
                </div>


                <div class="p-0 col-12" *ngIf="!smartViewUsedInModal" [ngClass]="smartViewUsedInForm ? '' : 'col-xl-7'">
                    <button [disabled]="submitButtonDisabled || !formGroup.valid || !formGroup.dirty" type="submit" class="btn btn-success mr-4 mb-4 mb-xl-0">{{ captionSaveText }}</button>
                    <button *ngIf="isCloseButtonRequired" type="button" (click)="closeEmitter.emit(false)" class="btn btn-danger mr-4 mb-4 mb-xl-0">Cancel</button>
                    <button *ngIf="!removeResetButton" [disabled]="!formGroup.dirty" class="btn btn-secondary mb-4 mb-xl-0" type="button" (click)="resetEvent.emit(true)">{{ resetCaption }}</button>
                </div>
            </div>
        </div>
    </form>
</div>
